import { useState, useEffect, useRef } from "react";
import { QuestionTracker } from "@shikaku/shared";

export function useQuestionTracker(namespace: string) {
  const trackerRef = useRef<QuestionTracker | null>(null);
  if (!trackerRef.current) {
    trackerRef.current = new QuestionTracker(namespace);
  }
  const tracker = trackerRef.current;

  const [, setTick] = useState(0);

  useEffect(() => {
    tracker.setOnChange(() => setTick((t) => t + 1));
    return () => tracker.setOnChange(() => {});
  }, [tracker]);

  return tracker;
}
